export function loadStateFromStorage<T>(storage: Storage, key: string): T | undefined {
  try {
    const serializedState = storage.getItem(key);
    if (serializedState === null) {
      return undefined;
    }
    return JSON.parse(serializedState);
  } catch (e) {
    return undefined;
  }
}

export function saveStateInStorage<T>(storage: Storage, key: string, state: T): void {
  try {
    const serializedState = JSON.stringify(state);
    storage.setItem(key, serializedState);
  } catch (e) {
    // ignore
  }
}
